// src/App.jsx
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";

import AdminMovieImport from "./pages/AdminMovieImport";
import AddShowtimes from "./pages/AddShowtimes";
import SeatManagement from "./pages/SeatManagement";

// ❌ Removed WeekMovieManager (no longer used)
// import WeekMovieManager from "./pages/WeekMovieManager";
import AdminAutoBackup from "./pages/AdminAutoBackup";
import UserManager from "./pages/UserManager";
import UserPOSDashboard from "./pages/UserPOSDashboard";
import ReportsStandalone from "./pages/ReportsStandalone";
import AdminSeatPlanner from "./pages/AdminSeatPlanner";
import AdminBarManager from "./pages/AdminBarManager";
import AdminFiscalDevices from "./pages/AdminFiscalDevices";
import CinemaLineup from "./pages/CinemaLineup.js";
import AdminRecatByStorno from "./pages/AdminRecatByStorno";

// ✅ NEW: Admin Restore Wizard
import AdminRestoreWizard from "./pages/AdminRestoreWizard";
import AdminMoviePricing from "./pages/AdminMoviePricing";
import AdminShowtimePricing from "./pages/AdminShowtimePricing";

// ✅ NEW: Admin Data tools
import AdminDataTools from "./pages/AdminDataTools";

// ✅ NEW: Promo Manager
import PromoManager from "./pages/PromoManager";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />

        {/* Admin */}
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/movies" element={<AdminMovieImport />} />
        <Route path="/admin/showtimes" element={<AddShowtimes />} />
        <Route path="/admin/seat-planner" element={<AdminSeatPlanner />} />
        <Route path="/admin/bar-manager" element={<AdminBarManager />} />
        <Route path="/admin/fiscal-devices" element={<AdminFiscalDevices />} />
        {/* ✅ NEW route */}
        <Route path="/admin/promos" element={<PromoManager />} />
        <Route path="/admin/movie-pricing" element={<AdminMoviePricing />} />
        <Route path="/admin/showtime-pricing" element={<AdminShowtimePricing />} />

        {/* Users / POS / Reports */}
        <Route path="/admin/users" element={<UserManager />} />
        <Route path="/user/dashboard" element={<UserPOSDashboard />} />
        <Route path="/reports" element={<ReportsStandalone />} />

        {/* Seats */}
        <Route path="/seats/:showtime_id" element={<SeatManagement />} />
        <Route path="/admin/manage-cinema-movies" element={<CinemaLineup />} />
        <Route path="/admin/recat" element={<AdminRecatByStorno />} />

        {/* Admin Tools */}
        <Route path="/admin/restore" element={<AdminRestoreWizard />} />
        <Route path="/admin/data-tools" element={<AdminDataTools />} />
        <Route path="/admin/auto-backup" element={<AdminAutoBackup />} />
      </Routes>
    </Router>
  );
}

export default App;
